import * as angular from 'angular';
import { ContentDocumentAdapterService } from './content-document-adapter.service';

const ContentDocumentAdapterModule = angular
    .module('mwAppComponents.adapters', [])
    .service('mwContentDocumentAdapterService', ContentDocumentAdapterService);
    // .name;

export { ContentDocumentAdapterModule }



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/content-document-adapter.module.ts